export default __webpack_public_path__ + "static/more_info_invictus-44c660616804121208d3ff98bae347c4.pdf";